// MainPage.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import NoItemsFound from '../components/NoItemsFound';
import DynamicTable from '../components/DynamicTable';
import TeamAliasModal from '../components/TeamAliasModal';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';
import { Link } from 'react-router-dom';

import {
  get_teamalias,
  get_teamalias_by_id,
  create_teamalias,
  update_teamalias,
  delete_teamalias,
} from '../api/api';


const AliasPage = () => {

  const { item_id } = useParams();
  const [ page, setPage] = useState(1);
  const [ aliasdata, setAliasdata] = useState(1);
  const [ alias, setAlias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const modalRef = useRef();
  const updateModalRef = useRef();

  const [q, setQ] = useState("");




  const newRowTemplate_alias = {}; //TODO

  const role = localStorage.getItem('role');
  const canAdd = role === 'Admin';
  const onAdd = ()=>{
    openAndResetModal();
  }

  const onEdit = ()=>{
    openAndResetUpdateModal();
  }


  const updateGrid = async () => {
      serverFiltering(q);
      /*const get_the_alias = async () => {
          const res = await get_teamalias();

          const data = res && res.data && res.data.data ? res.data.data : [];

          // HERE: this works just fine
          setAlias(data);     // Set state with resolved data
      };

      await get_the_alias();*/
  }


  const serverFiltering = async (q, sortModel = []) => {
    setLoading(true);

    setQ(q);

    const get_the_alias = async () => {
      const res = await get_teamalias(q, sortModel);
      const data = res?.data?.data || [];

      setAlias(data);
    };

    await get_the_alias();
    setLoading(false); // Fix: was calling `setLoading(true)` again
  };


  useEffect(() => {
      updateGrid();
  }, []);


  const openAndResetModal = () => {
    setModalOpen(true);
    setTimeout(() => {
      modalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };

  const openAndResetUpdateModal = () => {
    setUpdateModalOpen(true);
    setTimeout(() => {
      updateModalRef.current?.reset(); // ensure reset happens *after* modal is mounted
    }, 0);
  };



  const getColumDefs = (startEditing, stopEditing, setRecordToDelete, goToDetail) => {
    return [
      { field: "real_name",
        headerName: "Nome",

      },
      { field: "alias",
        headerName: "Alias",
        flex: 1

      }
    ];
  };


  const editCallback = async (val) => {


      const res = await get_teamalias_by_id(val);

      console.log(val);
      console.log(res);

      if(res && res.data){
        const the_alias = res.data.data;
        setAliasdata(the_alias);
        setUpdateModalOpen(true);
        setTimeout(() => {
          updateModalRef.current?.setup(the_alias); // ensure reset happens *after* modal is mounted
        }, 0);
      }
  };






  const setThePage = (page_id)=>{
    setPage(page_id);
  }

  return (
    <div>
      <TopBar />

      <div className="content">


        <div className="main-content">


          <div className="dynamic-table-topbar-right">
            <TitleBackButton
              title={"Gestione Alias"}
            />
            <div>
              { false && (
              <button className="dynamic-table-add-new" onClick={()=>{onAdd()}}>
                Aggiungi
              </button>
              )}
            </div>

          </div>

          <div className="dynamic-table-outer">

                <DynamicTable
                  items={alias}
                  getColumnDefs={getColumDefs}
                  deleteFunction={delete_teamalias}
                  showDownloadButtons={false}
                  editCallback={editCallback}
                  updateGrid={updateGrid}
                  serverFilteringFunction={serverFiltering}
                />
                <TeamAliasModal ref={modalRef}  isOpen={isModalOpen}  onClose={()=>{updateGrid(); setModalOpen(false)}}/>
                <TeamAliasModal aliasdata={aliasdata} ref={updateModalRef} isOpen={isUpdateModalOpen}  onClose={()=>{updateGrid(); setUpdateModalOpen(false)}}/>


            </div>

        </div>

      </div>
    </div>
  );
};

export default AliasPage;
